import '../Inscription.less';
import {Menu , Row, Col} from 'antd';
import { ApartmentOutlined,EyeOutlined, HomeOutlined,FileTextOutlined, TeamOutlined, UserOutlined, LogoutOutlined,UnorderedListOutlined } from '@ant-design/icons';
import React, { Component } from "react";
import cabezal from '../Cabezal.jpg'
import {NavLink} from "react-router-dom";

import {logout,centerStyle} from './utils';

/** *
* *Menu used in all Admin Views, the only variable is the reports menu, that receives as a param
*/
class AdminMenu extends Component {
  render() {  
    const { SubMenu } = Menu;
    return (
        <div>
          <Row>
            <Col><NavLink to="/culturasOriginarias/admin"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>
          <Row>
            <Col span={20}>
              <Menu style={centerStyle} mode="horizontal" defaultSelectedKeys={[this.props.defaultSelectedKey]}>
                <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/culturasOriginarias/admin"> Inicio</NavLink>
                </Menu.Item>
                <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/culturasOriginarias/admin_pan"> Paneles</NavLink>
                </Menu.Item>
                <Menu.Item key="pon" icon={<UnorderedListOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/culturasOriginarias/admin_pon'> Ponencias  </NavLink>
                </Menu.Item>
                <Menu.Item key="conc" icon={<UserOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink style={{fontSize:'20px', fontWeight:'bold'}} to='/culturasOriginarias/admin_conc'> Autores  </NavLink>
                </Menu.Item>
                {/* {this.props.reportMenu} */}
                
             
              </Menu>
            </Col>
            <Col span={4}>
              <Menu mode="horizontal">
                <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
                  <a onClick={logout}style={{fontSize:'20px', fontWeight:'bold', font:'black'}}> Cerrar sesión </a>
                </Menu.Item>
              </Menu>
            </Col>
          </Row>
          </div>
    );
  }
}
export default AdminMenu;


